export const FontConstants = {
  FONT_DEFAULT: 'Noto Sans',
  FONT_KR: 'Nanum',
  KOREA: 'KR',
};
